module.exports = __webpack_public_path__ + "produce-fresh-grass-05.jpg?d2a6e56c99a18490ce2bd402f199660f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-05.jpg
// module id = 42
// module chunks = 0